import React, { useRef, useEffect, useState, useMemo } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import JoditEditor from "jodit-react";
import api from "../helper/api";
import Cropper from "react-easy-crop";
import getCroppedImg from "../helper/cropImage";

const ListDealerCars = () => {
  const navigate = useNavigate();
  const [showTnc, setShowTnc] = useState(false);

  const config = useMemo(
    () => ({
      height: 400,
      toolbarAdaptive: false,
      buttons: [
        "bold",
        "italic",
        "underline",
        "|",
        "ul",
        "ol",
        "|",
        "font",
        "|",
        "align",
        "|",
        "link",
        "unlink",
        "fontsize",
      ],

      allowTabNavigation: true,
      saveModeInStorage: false,
      disablePlugins: ["pasteStorage"],
      readonly: false,
      enableDragAndDropFileToEditor: true,
      uploader: { insertImageAsBase64URI: true },
      placeholder: "Enter car specifications here...",
    }),
    []
  );

  const [registrationNumber, setRegistrationNumber] = useState("");
  const [currentMileage, setCurrentMileage] = useState("");
  const [fixedPrice, setFixedPrice] = useState("");
  const editor = useRef(null);
  const [specifications, setSpecifications] = useState("");
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [tel, setTel] = useState("");
  const [email, setEmail] = useState("");
  const [isCarData, setCarDataAv] = useState(false);
  const [isCarAccept, setIsCarAccept] = useState(true);
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [modelVarient, setModelVarient] = useState("");
  const [year, setYear] = useState("");
  const [postcode, setPostcode] = useState("");
  const [fuel_type, setFuelType] = useState("");
  const [color, setColor] = useState("");
  const [body_type, setBodyType] = useState("");
  const [transmission_type, setTransmissionType] = useState("");
  const [seating_capacity, setSeatingCapacity] = useState("");
  const [carDataDetail, setcarDataDetail] = useState([]);
  const [carEngineCapacity, setcarEngineCapacity] = useState();
  const [batteryCapacity, setBatteryCapacity] = useState("");
  const [electricRange, setElectricRange] = useState("");
  const [checking, setChecking] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [preview, setPreview] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [isAbleSubmit, setIsAbleSubmit] = useState(true);
  const [errors, setErrors] = useState({ mileage: "", email: "", phone: "", postcode: "" });

  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  const [cropMode, setCropMode] = useState("preview");
  const [galleryQueue, setGalleryQueue] = useState([]);

  useEffect(() => {
    if (galleryQueue.length > 0 && !showCropModal) {
      const nextFile = galleryQueue[0];
      setSelectedFileName(nextFile.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setCropMode("gallery");
        setShowCropModal(true);
      };
      reader.readAsDataURL(nextFile);
    }
  }, [galleryQueue, showCropModal]);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const resetForm = () => {
    setRegistrationNumber("");
    setCurrentMileage("");
    setFixedPrice("");
    setSpecifications("");
    setLoading(false);
    setImages([]);
    setCarDataAv(false);
    setIsCarAccept(true);
    setMake("");
    setModel("");
    setModelVarient("");
    setYear("");
    setFuelType("");
    setColor("");
    setBodyType("");
    setTransmissionType("");
    setSeatingCapacity("");
    setcarDataDetail([]);
    setcarEngineCapacity(undefined);
    setBatteryCapacity("");
    setElectricRange("");
    setChecking(false);
    setIsChecked(false);
    setPreview(null);
    setPreviewImg(null);
    setUploading(false);
    setIsAbleSubmit(true);
    setErrors({ mileage: "" });
  };

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  const checkDealerPlan = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/check/dealer-plan",
        {
          user_id: storedUserPreferences?.id,
        }
      );

      if (!response?.data?.status) {
        Swal.fire({
          title: "Unauthorized Access",
          text: "Your dealership plan expired or car listing limit expired!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#00889C",
          cancelButtonColor: "#d33",
          confirmButtonText: "Upgrade Now",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/dealer/plans");
          } else {
            navigate("/dealer/dashboard");
          }
        });
        return;
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };

  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };

  const storedUserPreferences = getDataFromlocalStorage("userData");

  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }

    if (
      !storedUserPreferences.postcode ||
      storedUserPreferences.postcode.trim() === ""
    ) {
      Swal.fire({
        title: "Postcode Required",
        text: "Please add your postcode in profile before continuing.",
        icon: "warning",
        confirmButtonColor: "#00889C",
        confirmButtonText: "Go to Profile",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/edit/dealer/profile");
        }
      });
      return;
    }

    setEmail(storedUserPreferences?.email);
    setTel(storedUserPreferences?.phone);
    setPostcode(storedUserPreferences.postcode || "");
    checkDealerPlan();
  }, []);

  const handleImageChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length > 0) {
      setGalleryQueue((prev) => [...prev, ...selectedFiles]);
    }
  };

  const removeImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };

  const addCarToList = () => {
    if (isCarData) {
      const formData = {
        owner_id: storedUserPreferences?.id,
        registration_number: registrationNumber,
        fixed_price: fixedPrice,
        make: make,
        model: model,
        model_varient: modelVarient,
        postcode: postcode,
        year: year,
        fuel_type: fuel_type,
        body_type: body_type,
        transmission_type: transmission_type,
        color: color,
        seating_capacity: seating_capacity,
        specifications: specifications,
        phone: tel,
        email: email,
        latitude: 40.7128,
        longitude: -74.006,
        images: images,
        previewImg: previewImg,
        current_mileage: currentMileage,
        engine_capacity: carEngineCapacity,
        battery_capacity: batteryCapacity,
        electric_range: electricRange,
        carData: carDataDetail,
      };

      axios
        .post(
          window.CARLOCA_API + "/car/save-in-publish",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          setLoading(false);
          if (res?.data?.status) {
            toast.success("Car Added Successfully In Publish List");
            resetForm();
            setCarDataAv(false);
            setPostcode(storedUserPreferences?.postcode || "");
          } else {
            toast.error(res?.data?.message, optionToast);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Please verify your car registration number!", optionToast);
    }
  };

  const getCarData = () => {
    setChecking(true);
    setIsAbleSubmit(true);
    
    api
      .get("/vehicle/" + registrationNumber)
      .then((res) => {
        setChecking(false);
        if (res?.data?.status) {
          const results = res?.data?.response?.Results;
          const vehicleId = results?.VehicleDetails?.VehicleIdentification;
          const modelDetails = results?.ModelDetails;
          const history = results?.VehicleDetails?.VehicleHistory;
          
          setMake(vehicleId?.DvlaMake);
          setModel(vehicleId?.DvlaModel);
          setModelVarient(modelDetails?.ModelIdentification?.ModelVariant || vehicleId?.DvlaModel || "Standard");
          setBodyType(modelDetails?.BodyDetails?.BodyStyle || vehicleId?.DvlaBodyType || "Unknown");
          setFuelType(modelDetails?.Powertrain?.FuelType || vehicleId?.DvlaFuelType);
          setColor(history?.ColourDetails?.CurrentColour || history?.ColourDetails?.OriginalColour || "Unknown");
          setTransmissionType(modelDetails?.Powertrain?.Transmission?.TransmissionType || (vehicleId?.DvlaModel?.toLowerCase().includes("auto") ? "Automatic" : "Manual"));
          setYear(vehicleId?.YearOfManufacture);
          setSeatingCapacity(modelDetails?.BodyDetails?.NumberOfSeats || results?.VehicleDetails?.DvlaTechnicalDetails?.NumberOfSeats || "5");
          setcarEngineCapacity(modelDetails?.Powertrain?.IceDetails?.EngineCapacityCc || results?.VehicleDetails?.DvlaTechnicalDetails?.EngineCapacityCc);
          setBatteryCapacity(modelDetails?.Powertrain?.TotalCapacityKwh || modelDetails?.Powertrain?.EvDetails?.TechnicalDetails?.BatteryDetailsList?.[0]?.TotalCapacityKwh || "");
          setElectricRange(modelDetails?.Powertrain?.CombinedRangeMiles || modelDetails?.Powertrain?.ElectricRangeMiles || modelDetails?.Powertrain?.EvDetails?.Performance?.RangeFigures?.RangeTestCycleList?.[0]?.CombinedRangeMiles || "");
          setcarDataDetail(results);
          
          setIsAbleSubmit(true);
          setCarDataAv(true);
          setIsCarAccept(true);
        } else {
          setCarDataAv(false);
          setIsCarAccept(true);
          setIsAbleSubmit(true);
          setMake("");
          setModel("");
          setModelVarient("");
          setBodyType("");
          setFuelType("");
          setColor("");
          setTransmissionType("");
          setYear("");
          setSeatingCapacity("");
          setcarEngineCapacity("");
          setBatteryCapacity("");
          setElectricRange("");
          setcarDataDetail("");
          
          if (typeof toast !== 'undefined' && typeof optionToast !== 'undefined') {
            toast.error(res?.data?.message || "Registration number not found!", optionToast);
          } else if (typeof toast !== 'undefined') {
            toast.error(res?.data?.message || "Registration number not found!");
          }
        }
      })
      .catch((err) => {
        setChecking(false);
        console.log(err);
        if (typeof toast !== 'undefined' && typeof optionToast !== 'undefined') {
          toast.error("Failed to fetch car data.", optionToast);
        }
      });
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const closeCropModal = () => {
    setShowCropModal(false);
    setImageSrc(null);
    if (cropMode === "gallery") {
      setGalleryQueue((prev) => prev.slice(1));
    }
  };

  const handleCropImage = async () => {
    try {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      const croppedFile = new File([croppedImageBlob], selectedFileName || "cropped_image.jpg", {
        type: "image/jpeg",
      });
      if (cropMode === "preview") {
        setPreviewImg(croppedFile);
        setPreview(URL.createObjectURL(croppedImageBlob));
      } else {
        setImages((prev) => [...prev, croppedFile]);
      }
      closeCropModal();
    } catch (error) {
      console.error("Error cropping image:", error);
    }
  };

  const handlePreviewImgChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setCropMode("preview");
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const isCarRegistrationExist = () => {
    setChecking(true);

    const formData = {
      registration_number: registrationNumber,
    };
    axios
      .post(
        window.CARLOCA_API + "/car/data",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        setChecking(false);
        if (res?.data?.code === 101) {
          getCarData();
        } else {
          toast.error(res?.data?.message, optionToast);
          setChecking(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!tel) {
      toast.error("Please fill in the phone number.", optionToast);
      return;
    }
    if (!email) {
      toast.error("Please fill in the email address.", optionToast);
      return;
    }
    if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address.", optionToast);
      return;
    }
    if (!registrationNumber) {
      toast.error("Please fill in the registration number.", optionToast);
      return;
    }
    if (!currentMileage) {
      toast.error("Please fill in the current mileage.", optionToast);
      return;
    }
    if (!fixedPrice) {
      toast.error("Please fill in the fixed price.", optionToast);
      return;
    }

    if (!specifications) {
      toast.error("Please fill in the specifications.", optionToast);
      return;
    }
    if (images.length === 0) {
      toast.error("Please add the images.", optionToast);
      return;
    }
    if (!isChecked) {
      toast.error("Please accept our terms & conditions", optionToast);
      return;
    }
    setLoading(true);
    addCarToList();
  };

  const validateMileage = (value) => {
    if (/^\d*$/.test(value)) {
      setErrors((prev) => ({ ...prev, mileage: "" }));
      setCurrentMileage(value);
    } else {
      setErrors((prev) => ({
        ...prev,
        mileage: "Please enter a valid current mileage (Like 20, 39, etc).",
      }));
    }
  };

  const validatePostcode = (value) => {
    setErrors((prev) => ({
      ...prev,
      postcode: "",
    }));
    setPostcode(value);
  };

  function backto() {
    window.history.back();
  }

  // Fixed JoditEditor handler to prevent cursor jumping
  const handleEditorChange = (content) => {
    // Only update if content actually changed to prevent unnecessary re-renders
    if (content !== specifications) {
      setSpecifications(content);
    }
  };

  return (
    <>
      <Navbar />
      <div className="new_page w-100 container-fluid">
        <div className="list_details add_car_container row  shadow-0  p-sm-4 p-0 mb-5 d-flex flex-column justify-content-center align-items-center">
          <form
            action=""
            className="col-md-8 d-flex flex-column justify-content-center mt-5"
          >
            <div className=" mt-4 d-flex justify-content-between align-items-center ">
              <h4 className="fs-4 fw-semibold mt-2 poppins-semibold">
                Add Your Car
              </h4>
              <button
                onClick={backto}
                type="button"
                className="btn btn-primary"
              >
                <i className="fa fa-arrow-back"></i>
                Back
              </button>
            </div>
            <div className="search-main w-100  mt-md-3 mt-3 p-0">
              <div className="card p-0 glassmorphism-1 shadow-0">
                <div className="card-body w-100 d-flex align-items-center justify-content-around">
                  <div className="input-group py-1  ">
                    <input
                      type="text"
                      placeholder="Enter Reg Here"
                      name="registration"
                      id="registration"
                      className="form-control form-control-lg"
                      value={registrationNumber}
                      onChange={(e) =>
                        setRegistrationNumber(
                          e.target.value.replace(/\s+/g, "")
                        )
                      }
                    />
                    <button
                      type="button"
                      onClick={isCarRegistrationExist}
                      disabled={checking}
                      className="decided-btn input-group-btn"
                    >
                      {checking ? "Checking..." : "Check"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {isCarData && (
              <div className="col-md-12 ">
                <div className="row border-0 justify-content-center">
                  <div className="col-sm-12 col-md-8">
                    <div className="ps-2">
                      <h4 className="fs-4 fw-semibold mt-5 mb-3 poppins-semibold">
                        Is This Your Car?
                      </h4>
                    </div>
                    <div className="card glassmorphism-1 ">
                      <div className="card-body p-md-5 p-3">
                        <div className="card border-0 rounded-3 shadow-lg">
                          <div className="card-body card_detail_list">
                            <ul>
                              <li>
                                <span className="list-heading">Make:</span>
                                <span className="list-text">{make}</span>
                              </li>
                              <li>
                                <span className="list-heading">Model:</span>
                                <span className="list-text">{model}</span>
                              </li>
                              <li>
                                <span className="list-heading">Year:</span>
                                <span className="list-text">{year}</span>
                              </li>
                              <li>
                                <span className="list-heading">Colour:</span>
                                <span className="list-text">{color}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {isCarAccept && (
                          <div className="d-flex pt-3 justify-content-around">
                            <button
                              onClick={() => {
                                setIsCarAccept(false);
                                toast.success(
                                  "Thanks for confirmation.",
                                  optionToast
                                );
                                setIsAbleSubmit(false);
                                const infoElement =
                                  document.querySelector("#info_about");
                                if (infoElement) {
                                  infoElement.scrollIntoView({
                                    behavior: "smooth",
                                  });
                                }
                              }}
                              type="button"
                              className="decided-btn"
                            >
                              Yes
                            </button>
                            <button
                              type="button"
                              className="decided-btn"
                              onClick={() => {
                                setCarDataAv(false);
                              }}
                            >
                              No
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Postcode Field */}
            <h5 className="py-3 fw-bolder mt-5">Car Location</h5>
            <div className="row">
              <div className="col-md-12 mb-0">
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder="Postcode"
                    value={postcode}
                    onChange={(e) => validatePostcode(e.target.value)}
                    style={{
                      borderColor: errors.postcode ? "red" : "",
                    }}
                  />

                  <i className="fa-solid fa-location-dot"></i>
                </div>
                {errors.postcode && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {errors.postcode}
                  </div>
                )}
                <small className="text-muted mb-0">
                  This is where potential buyers will view your car
                </small>
              </div>
            </div>

            <h3 className="py-3 pb-1 mt-5 fs-5 fw-bold">About The Car</h3>
            <div className="row">
              <div className="col-md-6 mb-3">
                <input
                  type="number"
                  step="0.01"
                  min={1}
                  className="form-control"
                  aria-label="Fixed Price"
                  placeholder="Fixed Price"
                  value={fixedPrice}
                  onChange={(e) => setFixedPrice(e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Current Mileage"
                  value={currentMileage}
                  onChange={(e) => validateMileage(e.target.value)}
                  style={{
                    borderColor: errors.mileage ? "red" : "",
                  }}
                />
                {errors.mileage && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {errors.mileage}
                  </div>
                )}
              </div>

              {(fuel_type?.toLowerCase().includes("electric") || fuel_type?.toLowerCase().includes("hybrid") || fuel_type?.toLowerCase().includes("bi fuel")) && (
                <>
                  <div className="col-md-6 mb-3">
                    <label className="mb-1" style={{ fontWeight: "500" }}>Battery Capacity (kWh)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="e.g. 27.5"
                      value={batteryCapacity}
                      onChange={(e) => setBatteryCapacity(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="mb-1" style={{ fontWeight: "500" }}>Electric Range (mi)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="e.g. 93"
                      value={electricRange}
                      onChange={(e) => setElectricRange(e.target.value)}
                    />
                  </div>
                </>
              )}

              <div className="col-12 mb-3 jd-editor">
                <JoditEditor
                  ref={editor}
                  value={specifications}
                  config={config}
                  tabIndex={1}
                  onBlur={handleEditorChange}

                />
              </div>
              <h5 className="fw-bold">Preview Image</h5>
              <div className="col-sm-4 col-6 ">
                <img
                  src={preview ? preview : `/img/noimg.jpeg`}
                  alt=""
                  style={{ width: "100%" }}
                  className="rounded-2"
                />
                <label
                  className="btn my-2 btn-primary btn-sm "
                  htmlFor="prevfile"
                  disabled={uploading}
                >
                  <i className="fa fa-edit"></i>
                </label>
                {uploading && <p>Uploading...</p>}
                <input
                  id="prevfile"
                  className="d-none"
                  type="file"
                  name="prevfile"
                  accept="image/*"
                  onChange={handlePreviewImgChange}
                />
              </div>
              <h5 className="fw-bold mt-3">Gallery Image</h5>
              <div className="col-12 mb-3">
                <div className="border text-center bg-white py-5">
                  <input
                    id="upload"
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="upload">
                    <img
                      style={{ width: "80px", cursor: "pointer" }}
                      src="/img/gallery_icon.png"
                      alt=""
                    />
                  </label>
                </div>
              </div>
              <div className="col-12 mb-3">
                {images.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      display: "inline-block",
                      position: "relative",
                      marginRight: "10px",
                    }}
                  >
                    <img
                      src={URL.createObjectURL(image)}
                      alt={`Car ${index + 1}`}
                      style={{ width: "100px" }}
                    />
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => removeImage(index)}
                      style={{ position: "absolute", top: "5px", right: "5px" }}
                    >
                      X
                    </button>
                  </div>
                ))}
              </div>
              <div className="col-12 mb-3">
                <div className="form-check blue px-0 ml-0 d-flex justify-content-start align-items-center">
                  <input
                    id="tandc"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    className="form-check-input inputcheck me-3 p-0"
                    style={{
                      height: 25,
                      width: 25,
                      marginLeft: 0,
                      fontSize: 16,
                    }}
                    type="checkbox"
                  />
                  <label
                    htmlFor="tandc"
                    className="form-check-label"
                    style={{ cursor: "pointer" }}
                  >
                    Accept our{" "}
                    <span
                      onClick={() => setShowTnc(true)}
                      className="text-primary"
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                      Terms & Conditions
                    </span>
                  </label>
                </div>
              </div>
              <div className="d-flex justify-content-center flex-column align-items-center">
                <button
                  onClick={handleSubmit}
                  className="btn btn-primary rounded-pill px-4 py-2 text-center"
                  disabled={isAbleSubmit || loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Uploading...
                    </>
                  ) : (
                    "Add To Publish List"
                  )}
                </button>
                <small className="text-primary mt-2">
                  {isAbleSubmit ? "Please verify your reg no." : ""}
                </small>

                <Link
                  to="/dealer/view-saved-cars"
                  className="btn btn-primary px-5 py-2 mt-4"
                >
                  View Your List
                </Link>
              </div>
            </div>
          </form>
        </div>

        <Footer />
      </div>
      {showTnc && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex={-1}
          onClick={() => setShowTnc(false)}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-scrollable"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="text-center fs-5 fw-bolder my-0 thank_heading mt-1">
                  Our Terms & Conditions
                </h4>
              </div>
              <div className="modal-body">
                <div className="row border-0 justify-content-center">
                  <div className="col-md-12">
                    <section className="mb-4">
                      <h2 className="fs-5 fw-bold">1. Introduction</h2>
                      <p>
                        Welcome to carloca. These terms and conditions outline
                        the rules and regulations for using our website and
                        services, including listing cars for sale and finding
                        cars for purchase.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h2 className="fs-5 fw-bold">2. Listing Cars for Sale</h2>
                      <p>
                        When listing a car for sale on carloca, you agree to
                        provide accurate and complete information about the
                        vehicle. You must ensure that all details, including the
                        car's condition, price, and other relevant information,
                        are truthful.
                      </p>
                      <p>
                        carloca reserves the right to remove any listings that
                        are deemed inappropriate, inaccurate, or in violation of
                        our policies.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h2 className="fs-5 fw-bold">
                        3. Finding Cars for Purchase
                      </h2>
                      <p>
                        carloca provides a platform for users to find cars for
                        purchase. We do not guarantee the accuracy or
                        reliability of the information provided by sellers. It
                        is the buyer's responsibility to verify the details of
                        the car and conduct due diligence before making a
                        purchase.
                      </p>
                      <p>
                        Any transactions or agreements made between buyers and
                        sellers are solely between the parties involved. carloca
                        is not responsible for any disputes, issues, or losses
                        arising from such transactions.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h2 className="fs-5 fw-bold">4. User Responsibilities</h2>
                      <p>
                        By using carloca, you agree to use the platform in
                        compliance with all applicable laws and regulations. You
                        are responsible for maintaining the confidentiality of
                        your account information and for all activities that
                        occur under your account.
                      </p>
                      <p>
                        You agree not to use carloca for any unlawful purposes
                        or in a manner that could damage, disable, or impair the
                        platform.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h2 className="fs-5 fw-bold">
                        5. Limitation of Liability
                      </h2>
                      <p>
                        carloca shall not be liable for any indirect,
                        incidental, special, or consequential damages arising
                        from the use of our platform. We do not guarantee the
                        availability, reliability, or accuracy of the services
                        provided.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h2 className="fs-5 fw-bold">6. Changes to Terms</h2>
                      <p>
                        carloca reserves the right to modify these terms and
                        conditions at any time. Any changes will be posted on
                        this page, and it is your responsibility to review the
                        terms periodically. Your continued use of the platform
                        constitutes acceptance of any changes.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h2 className="fs-5 fw-bold">7. Contact Us</h2>
                      <p>
                        If you have any questions or concerns about these terms
                        and conditions, please contact us at{" "}
                        <a className="blue" href="mailto:support@carloca.uk">
                          support@carloca.uk
                        </a>
                        .
                      </p>
                    </section>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowTnc(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCropModal && (
        <div className="modal fade show" tabIndex="-1" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Crop Your Photo</h5>
                <button type="button" className="btn-close" onClick={closeCropModal}></button>
              </div>
              <div className="modal-body">
                <div style={{ position: "relative", height: "300px", width: "100%" }}>
                  <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={4 / 3}
                    minZoom={1}
                    maxZoom={3}
                    restrictPosition={true}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>
                <div className="mt-3 px-2">
                  <label className="form-label fs-6 fw-semibold mb-1">Zoom Control</label>
                  <div className="d-flex align-items-center gap-2">
                    <i className="fa-solid fa-magnifying-glass-minus text-muted"></i>
                    <input
                      type="range"
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      aria-label="Zoom"
                      onChange={(e) => setZoom(parseFloat(e.target.value))}
                      className="form-range flex-grow-1"
                    />
                    <i className="fa-solid fa-magnifying-glass-plus text-muted"></i>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={closeCropModal}>Cancel</button>
                <button className="btn btn-primary btn-sm" onClick={handleCropImage}>
                  <i className="fa-solid fa-crop me-1"></i>Crop &amp; Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default ListDealerCars;
